import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { Form, Button, Row, Col, Card } from "react-bootstrap";
import axios from "axios";

// Import the loader from lders
import { grid } from "ldrs";
grid.register();

const Step3 = ({ isActive, onNext }) => {
  const { t } = useTranslation();
  const [selectedIndustry, setSelectedIndustry] = useState("");
  const [industries, setIndustries] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchSelectedItem = async () => {
    try {
      const response = await axios.get("/get-step-response", {
        params: { stepNumber: 3 },
      });
      if (response.data.status && response.data.fieldId) {
        setSelectedIndustry(response.data.fieldId);
      }
    } catch (error) {
      console.error("Error fetching selected item:", error);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post("/save-steps", {
        stepNumber: 3,
        fieldId: selectedIndustry,
      });

      if (response.data.status) {
        // alert(response.data.message);
        onNext(); // Move to the next step
      } else {
        alert(t('steps.failedToSaveStep'));
      }
    } catch (error) {
      console.error("Error saving step:", error);
      alert(t('steps.errorSavingStep'));
    }
  };

  useEffect(() => {
    if (isActive) {
      fetchSelectedItem();

      const fetchIndustries = async () => {
        setLoading(true);
        try {
          const response = await axios.get(`/step3-values`);
          if (response.data.status) {
            setIndustries(response.data.step3Values);
          } else {
            alert(t('steps.failedToLoadIndustries') + ": " + response.data.message);
          }
        } catch (error) {
          console.error("Error fetching industries:", error);
          alert(t('steps.errorFetchingIndustries'));
        } finally {
          setLoading(false);
        }
      };

      fetchIndustries();
    }
  }, [isActive]);

  if (!isActive) {
    return null; // Render nothing if the step is not active
  }

  if (loading) {
    return (
      <div className="text-center py-5">
        <l-grid
          size="60"
          speed="1.5"
          color="#2F855A" // Tea Pink color
        ></l-grid>
        <p>{t('steps.loadingIndustries')}</p>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <Card className="p-4" style={{ border: "none" }}>
        <Card.Body>
        <h5 className="text-[30px] mb-4 font-semibold leading-[110%] text-[#25324B] tracking-wide">
            {t('steps.selectIndustry')}
          </h5>
          <Form onSubmit={handleSave}>
          <Row>
            {industries.map((industry, index) => (
              <Col key={index} md={6} lg={4} className="mb-4">
                <Card
                  className={`h-100 bg-white border rounded-lg cursor-pointer transition-all duration-300 ease-in-out 
                    ${selectedIndustry === industry.id ? "border-success shadow" : "border-gray-300"}`}
                  onClick={() => setSelectedIndustry(industry.id)}
                  style={{ cursor: "pointer" }}
                >
                  <Card.Body className="d-flex flex-column p-4">
                    {/* Hidden Radio Button */}
                    <Form.Check
                      type="radio"
                      id={`industry-${index}`}
                      name="industry"
                      value={industry.id}
                      checked={selectedIndustry === industry.id}
                      onChange={() => setSelectedIndustry(industry.id)}
                      className="d-none"
                    />

                    {/* 🌟 Sector Name - Now Matching Your Style */}
                    <h5
                      className={`text-[23px] font-semibold leading-[110%] text-center tracking-wide ${
                        selectedIndustry === industry.id ? "text-success" : "text-[#25324B]"
                      }`}
                    >
                      {industry.sectorName}
                    </h5>

                    {/* ✅ Justified Sector Description */}
                    <p className="mb-0 text-muted text-justify" style={{ textAlign: "justify" }}>
                      {industry.sectorDetail}
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
            <div className="d-flex justify-content-end mt-4">
              <Button
                type="submit"
                className="btn btn-success px-4 fs-5"
                disabled={!selectedIndustry}
              >
{t('steps.next')}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Step3;
